import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconArrowLeft } from '@tabler/icons-react';

export function BackLink({ to, label = 'Back' }: { to?: string; label?: string }) {
  const navigate = useNavigate();
  return (
    <button type="button" className="rides-backlink" onClick={() => (to ? navigate(to) : navigate(-1))}>
      <IconArrowLeft size={20} aria-hidden="true" /> {label}
    </button>
  );
}

/** Optional eyebrow + display title (h1) + lede: the top of every page. Steps use StepHeader (components/ui). */
export function PageIntro({ eyebrow, title, lede }: { eyebrow?: ReactNode; title: ReactNode; lede?: ReactNode }) {
  return (
    <header>
      {eyebrow && <p className="rides-eyebrow">{eyebrow}</p>}
      <h1 className="rides-title">{title}</h1>
      {lede && <p className="rides-lede">{lede}</p>}
    </header>
  );
}

/** Section heading inside a page (an h2, so screen-reader users can jump between sections). */
export function SectionLabel({ children, hint }: { children: ReactNode; hint?: ReactNode }) {
  return (
    <h2 className="rides-sectlabel">
      {children}
      {hint && <> <span>· {hint}</span></>}
    </h2>
  );
}

export function Callout({ kind = 'info', icon, children }: { kind?: 'info' | 'warn' | 'bad' | 'ok'; icon?: ReactNode; children: ReactNode }) {
  return (
    <div className={`rides-callout ${kind}`}>
      {icon && <span className="ic" aria-hidden="true">{icon}</span>}
      <span>{children}</span>
    </div>
  );
}

export function SummaryRow({ k, v, sub }: { k: ReactNode; v: ReactNode; sub?: ReactNode }) {
  return (
    <div className="rides-srow">
      <span className="k">{k}</span>
      <span className="v">
        {v}
        {sub && <small>{sub}</small>}
      </span>
    </div>
  );
}
